import { Pipe, PipeTransform } from '@angular/core';
import { MessageStatus } from '../enums/message-status';

@Pipe({name: 'messageStatus'})
export class MessageStatusPipePipe implements PipeTransform {
  transform(value: MessageStatus): { label: string, color: string } {
    switch (value) {
      case MessageStatus.accepted:
        return { label: 'Accepted', color: 'var(--third-color)' };
      case MessageStatus.queued:
        return { label: 'Queued', color: 'var(--third-color)' };
      case MessageStatus.sending:
        return { label: 'Sending', color: 'var(--third-color)' };
      case MessageStatus.sent:
        return { label: 'Sent', color: 'var(--success-color)' };
      case MessageStatus.failed:
        return { label: 'Failed', color: 'var(--alert-color-2)' };
      case MessageStatus.delivered:
        return { label: 'Delivered', color: 'var(--success-color)' };
      case MessageStatus.undelivered:
        return { label: 'Undelivered', color: 'var(--alert-color-2)' };
      case MessageStatus.read:
        return { label: 'Read', color: 'var(--success-color)' };
      case MessageStatus.unsubscribed:
        return { label: 'Unsubscribed', color: 'var(--alert-color-2)' };
      default:
        return { label: 'Unknown', color: 'gray' };
    }
  }
}
